<template>
  <v-card>
    <v-card-text
      class="pt-4"
      style="position: relative;"
    >
      <div class="pl-3">
        <h3 class="display-1 font-weight-light orange--text mb-2">Precifique seus produtos</h3>
        <div class="font-weight-light title mb-2">
          Temos uma lista de combustíveis cadastrados<br>
          mas precisamos que você nos diga o preço na bomba.
        </div>
      </div>
      <v-list two-line subheader>
        <v-list-tile
          v-for="item in prices"
          :key="item.id_combustivel"
          avatar
        >
          <v-list-tile-avatar :color="item.combustivel.color">
            <img :src="require(`@/assets/combs/${item.combustivel.icone}.svg`)" style="width: 56px"/>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.combustivel.nome }}</v-list-tile-title>
            <v-list-tile-sub-title>{{ item.combustivel.nome }}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-text-field
              v-model="item.price"
              prefix="R$"
              v-money="money"
            ></v-text-field>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        flat
        color="primary"
        @click="cadastrarItem"
      >
        Salvar e finalizar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'

export default {
  data () {
    return {
      prices: [],
      money: {
        decimal: '.',
        thousands: ',',
        precision: 2,
        masked: false
      }
    }
  },
  beforeMount () {
    this.prices = this.combustiveis.map((combustivel) => {
      return {
        id_combustivel: combustivel.id_combustivel,
        price: '0.00',
        combustivel: combustivel,
        posto: this.posto.cnpj,
        tipo: 'P',
        nome: combustivel.nome
      }
    })
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    posto () {
      return this.$store.getters.posto
    }
  },
  methods: {
    cadastrarItem () {
      const itens = this.prices.filter((p) => p.price !== '0.00' && p.price !== undefined)
      if (itens.length === 0) {
        let combustiveis = []
        this.$store.commit('precificarPosto', combustiveis)
        return
      }
      const data = {
        method: 'POST',
        itens: itens,
        posto: this.posto.cnpj
      }
      return this.$store.dispatch('cadastrarMuitosCombustiveis', data).then(() => {
        let combustiveis = []
        this.$store.commit('precificarPosto', combustiveis)
      })
    }
  },
  directives: { money: VMoney }
}
</script>
